import { render, staticRenderFns } from "./AvisoServicio.vue?vue&type=template&id=282025ba&scoped=true"
import script from "./AvisoServicio.vue?vue&type=script&lang=js"
export * from "./AvisoServicio.vue?vue&type=script&lang=js"
import style0 from "./AvisoServicio.vue?vue&type=style&index=0&id=282025ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "282025ba",
  null
  
)

export default component.exports